// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2025 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { cartLinkStyles } from "@ces/Overrides/Widgets/Common/CartLink";
import { xScreen } from "@ces/XDL/Utilities";
import { css } from "styled-components";

cartLinkStyles.cartLink = {
    cartLines: {
        css: css`
            ${xScreen("gt", "md")} {
                margin-left: 20px;
            }
        `,
    },
    icon: {
        css: css`
            &,
            svg {
                width: 20px;
            }
            ${xScreen("gt", "md")} {
                margin-left: 32px;
            }
        `,
    },
};
